import { render } from "./DettagliCliente.vue?vue&type=template&id=f1ad151c&scoped=true"
import script from "./DettagliCliente.vue?vue&type=script&lang=js"
export * from "./DettagliCliente.vue?vue&type=script&lang=js"

import "./DettagliCliente.vue?vue&type=style&index=0&id=f1ad151c&scoped=true&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ad151c"]])

export default __exports__